export const ContactsUploaderStyle = {
	title: {
		fontWeight: 'bold',
	},

	list: {
		display: 'flex',
		gap: '16px',
		padding: '6px 16px',
		marginTop: '16px',
		marginBottom: '24px',
		background: 'var(--neutral-100)',
		borderRadius: '8px',
	},
	item: {
		width: '100%',
		maxWidth: '101px',
		color: 'var(--neutral-500)',
	},
	uploaderArea: {
		border: '2px dashed var(--primary-500)',
		borderRadius: '8px',
		padding: '300px 440px',
	},
	text: {
		marginBottom: '16px',
	},

	wrapper: {
		paddingBottom: '48px',
		height: '100%',
	},

	radioGroup: {
		marginTop: '80px',
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		alignItems: 'center',
	},

	buttonWrapper: {
		position: 'absolute',
		bottom: '0px',
		left: '0px',
		right: '0px',
		padding: '16px 385px',
		background: 'var(--neutral-100)',
	},
};
